import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="app-container">
      <div className="background-pattern"></div>

      <div className="main-content">
        <div className="legal-header">
          <img
            src="/logo.png"
            alt="Auto Shiny Counter Logo"
            className="app-logo"
          />
          <h1 className="title">Website Privacy Policy</h1>
          <p className="legal-date">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Website Privacy Policy</h2>
            <p>
              This privacy policy describes how this website ("the Website")
              handles your information. We are committed to protecting your
              privacy and ensuring transparency about our data practices.
            </p>
          </section>

          <section className="legal-section">
            <h2>Information We Collect</h2>
            <p>
              This website does not collect, store, or process any personal
              information from visitors. We do not use cookies, tracking pixels,
              analytics tools, or any other data collection mechanisms. Your
              visit to this website is completely anonymous.
            </p>
          </section>

          <section className="legal-section">
            <h2>No Tracking or Analytics</h2>
            <p>
              We do not use Google Analytics, Facebook Pixel, or any other
              tracking services. We do not monitor your browsing behavior,
              collect IP addresses, or track your interactions with this
              website.
            </p>
          </section>

          <section className="legal-section">
            <h2>No Cookies</h2>
            <p>
              This website does not use cookies or any other local storage
              mechanisms to store information on your device. Your browser will
              not store any data related to your visit to this website.
            </p>
          </section>

          <section className="legal-section">
            <h2>Third-Party Services</h2>
            <p>
              This website contains links to external app stores (Apple App
              Store and Google Play Store) and donation buttons. When you click
              these links or interact with the donation buttons, you will be
              redirected to those third-party services, which have their own
              privacy policies. We do not receive any data from these
              interactions.
            </p>
          </section>

          <section className="legal-section">
            <h2>Server Logs</h2>
            <p>
              Our web hosting service may maintain standard server logs for
              technical purposes (such as monitoring uptime), but we do not
              access, analyze, or use this data for any tracking or marketing
              purposes.
            </p>
          </section>

          <section className="legal-section">
            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with an updated revision date. Since
              we don't collect any contact information, we cannot notify you of
              changes directly.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, you can
              contact us through the app store reviews or other publicly
              available contact methods.
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <a href="/" className="back-link">
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}
